import React, { Fragment } from "react";
import SearchProduct from "../SearchProduct";
import { globalFileServer } from "../../../../axiosInstance";

const ProductEditPerloed = ({
  products,
  onSelectProduct,
  arrShow,
  removeLinkage,
  label,
}) => {
  return (
    <Fragment>
      <div className="product-linkage">
        <p className="product-linkage__label">{label}</p>
        <SearchProduct products={products} onSelectProduct={onSelectProduct} />
        {arrShow.length
          ? arrShow.map((alter, ind) => {
              return (
                <div className="linkage-items" key={ind}>
                  <p>{alter.ProductName}</p>
                  <div
                    onClick={() => removeLinkage(alter.ProductMkt)}
                    className="img"
                  >
                    <img
                      loading="lazy"
                      src={globalFileServer + "iconcss/close-menu.svg"}
                      alt=""
                    />
                  </div>
                </div>
              );
            })
          : null}
      </div>
    </Fragment>
  );
};

export default ProductEditPerloed;
